import { render, staticRenderFns } from "./Exercises.vue?vue&type=template&id=69745425&scoped=true&lang=pug&"
import script from "./Exercises.vue?vue&type=script&lang=ts&"
export * from "./Exercises.vue?vue&type=script&lang=ts&"
import style0 from "./Exercises.vue?vue&type=style&index=0&id=69745425&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69745425",
  null
  
)

export default component.exports